export enum PaymentOptions {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL'
}
